import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AppProviders } from './app/providers'
import { AppRouter } from './app/router'
import { capturePWAInstallPrompt } from './features/pwa/usePWAInstall'
import './design-system/tokens.css'

// beforeinstallprompt dispara UMA vez e cedo, antes de qualquer componente
// montar. Capturar no boot é a única forma de ainda poder instalar por
// botão depois. Ver docs/specs/11-pwa.md.
capturePWAInstallPrompt()

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root não encontrado.')

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
)
